module.exports = __webpack_public_path__ + "8bbba59029be362ee1e53db8203f0ab3.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_r_70.mp3
// module id = 426
// module chunks = 0